export default __webpack_public_path__ + "static/media/location_preview_s5_mammoth_mountain.23e1c466.svg";